import { DisplayLink } from '@/ui/Link'
import { Message } from '@/ui/Message/Message'
import NextImage from 'next/legacy/image'
import { reprintDigitalMessage, reprintPrintedMessage } from '../pdp.constants'
import styles from './ReprintMessage.module.scss'

interface ReprintMessageProps {
  productType: 'digital' | 'printed'
}
export function ReprintMessage({ productType }: ReprintMessageProps) {
  const isDigital = productType === 'digital'
  return (
    <>
      {isDigital ? (
        <Message isVisible={true}>
          <Message.Content style={{ order: reprintDigitalMessage.order.content }}>
            <Message.Title className={styles.title}>{reprintDigitalMessage.title}</Message.Title>
          </Message.Content>
        </Message>
      ) : (
        <Message isVisible={true}>
          <Message.Content style={{ order: reprintPrintedMessage.order.content }}>
            <Message.Title className={styles.title}>{reprintPrintedMessage.title}</Message.Title>
            <Message.Text className={styles.text}>
              {reprintPrintedMessage.text}{' '}
              {reprintPrintedMessage.href && reprintPrintedMessage.linkText && (
                <DisplayLink
                  href={reprintPrintedMessage.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  color="secondary"
                  size="md"
                >
                  {reprintPrintedMessage.linkText}
                </DisplayLink>
              )}
            </Message.Text>
          </Message.Content>
          <Message.Image style={{ order: reprintPrintedMessage.order.image }}>
            <NextImage
              unoptimized
              src={reprintPrintedMessage.image}
              alt="reprint-icon"
              layout="fixed"
              width={38}
              height={40}
            />
          </Message.Image>
        </Message>
      )}
    </>
  )
}
